
import {
	Vue,
	Component,
	Prop,
	PropSync,
	Watch,
	Inject
} from "vue-property-decorator";
import Marquee from "@/components/semantics/Marquee.vue";
import SortHeader from "@/components/base/table/header/SortHeader.vue";
import { Action, Getter } from "vuex-class";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import { deepClone, getAreaCN, getParentArea } from "@/common/utils";
import { pageViewUnit } from "@/config";
@Component({
	name: "Inform",
	components: {
		Marquee,
		SortHeader,
		Pagination
	}
})
export default class Apply extends Vue {
	@Action("policy/getInformList") private getInformList: any;
	@Getter("cityName") private cityName: any;
	@Getter("cityId") private cityId: any;
	areaOption = this.$root.$data.areaOption;
	searchValue: string = "";
	loading = false;
	tableData: any = [];
	total = 0;
	pages = 0;
	current = 1;
	size = 15;
	current_option: any = {};
	created() {
		this.getData();
	}
	async getData(type = 0) {
		// 0-default|1-search
		this.loading = true;
		const {
			centerId,
			provinceId,
			cityId,
			cityList
		} = this.$root.$data.currentAreaProps;
		const allArea = cityList.concat([centerId, provinceId, cityId]);
		let options: any = {
			current: this.current,
			size: this.size,
			addressCodeList: allArea,
			listType: 1
		};

		this.current_option.addressCodeList = allArea;
		if (type === 1) {
			if (options.addressCode || this.current_option.addressCode) {
				this.current_option.addressCodeList = null;
			}
			options.addressCodeList = null;
			options = {
				...options,
				...this.current_option
			};
		}
		this.getInformList(options)
			.then(({ code, data, msg }: any) => {
				if (code === 0) {
					const { total, records, pages } = data;
					this.tableData = records.map((item: any) => {
						item.pageView = (item.pageView ? item.pageView : 0) + pageViewUnit;
						item.addressCN = getAreaCN(this.areaOption, item.addressCode);
						return item;
					});
					this.pages = pages;
					this.total = total;
				}
			})
			.finally(() => (this.loading = false));
	}
	clickMarquee(options: any) {
		options.addressCode ? options.addressCode : this.cityId;
		this.current_option = options;
		this.getData(1);
	}
	currentChange(params: any) {
		this.current = params;
		this.getData(1);
	}
	search(options: any) {
		this.current_option = {
			...this.current_option,
			...options
		};
		this.getData(1);
	}
	toDetail(item: any) {
		const { id: informId } = item;

		this.$router.push({
			path: "/detail/inform",
			query: {
				informId
			}
		});
	}
}
